(function(){

  /* ── TARIFS ── */
  var PRICING = {
    '20x24': [{min:100,max:199,pu:3.50},{min:200,max:499,pu:2.95},{min:500,max:999,pu:2.50},{min:1000,max:99999,pu:2.10}],
    '30x60': [{min:100,max:199,pu:7.00},{min:200,max:499,pu:5.95},{min:500,max:999,pu:5.10},{min:1000,max:99999,pu:4.30}],
    '40x90': [{min:100,max:199,pu:12.00},{min:200,max:499,pu:10.20},{min:500,max:999,pu:8.75},{min:1000,max:99999,pu:7.40}]
  };
  function getUP(fmt,q){ var t=PRICING[fmt]; for(var i=0;i<t.length;i++){ if(q>=t[i].min&&q<=t[i].max)return t[i].pu; } return t[t.length-1].pu; }
  function fmt2(n){ return n.toFixed(2).replace('.',',')+' \u20ac'; }

  /* ── STATE ── */
  var matSz='20x24';
  var color='#0D0D12', dark=true;
  var qty=100;

  /* Elements: { id, img, name, x, y, w, h, sizePct } */
  var elements=[], activeIdx=null;
  var dragging=false, dragOffX=0, dragOffY=0;
  var resizing=false, resizeIdx=null, resizeStartX=0, resizeStartW=0;

  /* ── DOM ── */
  var canvas   = document.getElementById('spCanvas');
  var ctx      = canvas.getContext('2d');
  var picker   = document.getElementById('spPicker');
  var ccSwatch = document.getElementById('spCcSwatch');
  var ccHex    = document.getElementById('spCcHex');
  var qtyInput = document.getElementById('spQty');
  var elList   = document.getElementById('spElList');

  /* ── COLOUR ── */
  function applyColor(h){
    color=h; dark=isDark(h);
    ccSwatch.style.background=h; ccHex.textContent=h.toUpperCase(); draw();
  }
  picker.addEventListener('input',function(){ applyColor(this.value); });
  picker.addEventListener('change',function(){ applyColor(this.value); });
  ccSwatch.style.background=color;

  function isDark(h){
    var c=h.replace('#',''); if(c.length===3)c=c[0]+c[0]+c[1]+c[1]+c[2]+c[2];
    return(0.299*parseInt(c.slice(0,2),16)+0.587*parseInt(c.slice(2,4),16)+0.114*parseInt(c.slice(4,6),16))/255<0.55;
  }

  /* ── CANVAS ── */
  function asp(){
    if(matSz==='40x90') return 90/40;
    if(matSz==='20x24') return 24/20;
    return 60/30;
  }

  function resize(){
    var maxW=canvas.parentElement.offsetWidth;
    var w,h;
    if(matSz==='20x24'){ w=Math.round(maxW*.6); h=Math.round(w/(24/20)); }
    else { w=maxW; h=Math.round(w/asp()); }

    var oldW=canvas.width, oldH=canvas.height;
    if(oldW>0 && oldH>0 && elements.length>0){
      var scX=w/oldW;
      var scY=h/oldH;
      elements.forEach(function(el){
        el.x*=scX;
        el.y*=scY;
      });
    }

    canvas.width=w; canvas.height=h;

    elements.forEach(function(el){
      recomputeDims(el);
      el.x=Math.max(0,Math.min(el.x,canvas.width-el.w));
      el.y=Math.max(0,Math.min(el.y,canvas.height-el.h));
    });

    draw();
  }

  function rr(x,y,w,h,r){
    ctx.beginPath(); ctx.moveTo(x+r,y); ctx.lineTo(x+w-r,y); ctx.quadraticCurveTo(x+w,y,x+w,y+r);
    ctx.lineTo(x+w,y+h-r); ctx.quadraticCurveTo(x+w,y+h,x+w-r,y+h);
    ctx.lineTo(x+r,y+h); ctx.quadraticCurveTo(x,y+h,x,y+h-r);
    ctx.lineTo(x,y+r); ctx.quadraticCurveTo(x,y,x+r,y); ctx.closePath();
  }

  function draw(){
    var W=canvas.width,H=canvas.height;
    ctx.clearRect(0,0,W,H);
    ctx.fillStyle=color; rr(0,0,W,H,Math.round(W*.018)); ctx.fill();
    var v=ctx.createRadialGradient(W/2,H/2,H*.06,W/2,H/2,W*.75);
    v.addColorStop(0,'rgba(0,0,0,0)'); v.addColorStop(1,'rgba(0,0,0,.2)');
    ctx.fillStyle=v; rr(0,0,W,H,Math.round(W*.018)); ctx.fill();

    var m=Math.round(W*.012);
    var r2=Math.round(W*.012);
    var la=dark?.35:.25;
    var stitchColor=dark?'rgba(255,255,255,'+la+')':'rgba(0,0,0,'+la+')';

    ctx.strokeStyle=stitchColor;
    ctx.lineWidth=1.5;
    ctx.setLineDash([]);
    ctx.beginPath();
    ctx.moveTo(m+r2,m); ctx.lineTo(W-m-r2,m);
    ctx.quadraticCurveTo(W-m,m,W-m,m+r2);
    ctx.lineTo(W-m,H-m-r2);
    ctx.quadraticCurveTo(W-m,H-m,W-m-r2,H-m);
    ctx.lineTo(m+r2,H-m);
    ctx.quadraticCurveTo(m,H-m,m,H-m-r2);
    ctx.lineTo(m,m+r2);
    ctx.quadraticCurveTo(m,m,m+r2,m);
    ctx.closePath();
    ctx.stroke();

    ctx.strokeStyle=stitchColor;
    ctx.lineWidth=1;
    ctx.setLineDash([4,4]);
    ctx.beginPath();
    ctx.moveTo(m+r2,m); ctx.lineTo(W-m-r2,m);
    ctx.quadraticCurveTo(W-m,m,W-m,m+r2);
    ctx.lineTo(W-m,H-m-r2);
    ctx.quadraticCurveTo(W-m,H-m,W-m-r2,H-m);
    ctx.lineTo(m+r2,H-m);
    ctx.quadraticCurveTo(m,H-m,m,H-m-r2);
    ctx.lineTo(m,m+r2);
    ctx.quadraticCurveTo(m,m,m+r2,m);
    ctx.closePath();
    ctx.stroke();
    ctx.setLineDash([]);

    elements.forEach(function(el,i){
      ctx.drawImage(el.img,el.x,el.y,el.w,el.h);
      if(activeIdx===i){
        ctx.strokeStyle='rgba(30,95,216,.7)'; ctx.lineWidth=2; ctx.setLineDash([5,4]);
        ctx.strokeRect(el.x-3,el.y-3,el.w+6,el.h+6); ctx.setLineDash([]);
        ctx.fillStyle='#1E5FD8';
        ctx.beginPath(); ctx.arc(el.x+el.w,el.y+el.h,7,0,Math.PI*2); ctx.fill();
      }
    });
  }

  /* ── ELEMENT HELPERS ── */
  function recomputeDims(el){
    var maxW=canvas.width*(el.sizePct/100);
    var sc=Math.min(maxW/el.img.width,(canvas.height*.7)/el.img.height);
    el.w=el.img.width*sc; el.h=el.img.height*sc;
  }

  function createEl(img,name){
    var el={ id:Date.now()+Math.random(), img:img, name:name, sizePct:30, x:0,y:0,w:0,h:0 };
    recomputeDims(el);
    el.x=(canvas.width-el.w)/2; el.y=(canvas.height-el.h)/2;
    return el;
  }

  function renderList(){
    elList.innerHTML='';
    elements.forEach(function(el,i){
      var item=document.createElement('div');
      item.className='el-item'+(activeIdx===i?' active':'');

      var row=document.createElement('div');
      row.className='el-item-row';

      var thumb=document.createElement('div'); thumb.className='el-thumb';
      var tImg=document.createElement('img'); tImg.src=el.img.src; thumb.appendChild(tImg);

      var name=document.createElement('span'); name.className='el-name'; name.textContent=el.name;

      var del=document.createElement('button'); del.className='el-del'; del.innerHTML='\u00d7'; del.title='Supprimer';
      del.addEventListener('click',function(e){
        e.stopPropagation();
        elements.splice(i,1);
        if(activeIdx===i) activeIdx=null;
        else if(activeIdx>i) activeIdx--;
        renderList(); draw();
      });

      row.appendChild(thumb); row.appendChild(name); row.appendChild(del);
      row.addEventListener('click',function(){ activeIdx=(activeIdx===i)?null:i; renderList(); draw(); });
      item.appendChild(row);

      if(activeIdx===i){
        var sr=document.createElement('div'); sr.className='el-slider-row';
        var rng=document.createElement('input'); rng.type='range'; rng.min=5; rng.max=90; rng.step=1; rng.value=el.sizePct;
        var lbl=document.createElement('span'); lbl.className='el-slider-lbl'; lbl.textContent=el.sizePct+'%';
        rng.addEventListener('input',function(){
          el.sizePct=parseInt(this.value); lbl.textContent=el.sizePct+'%';
          recomputeDims(el);
          el.x=Math.max(0,Math.min(el.x,canvas.width-el.w));
          el.y=Math.max(0,Math.min(el.y,canvas.height-el.h));
          draw();
        });
        sr.appendChild(rng); sr.appendChild(lbl);
        item.appendChild(sr);
      }

      elList.appendChild(item);
    });
  }

  /* ── UPLOAD ── */
  var upInput=document.getElementById('spUpload');
  var upZone =document.getElementById('spUpZone');

  upInput.addEventListener('change',function(){
    Array.from(this.files).forEach(function(f){ loadFile(f); });
    this.value='';
  });
  upZone.addEventListener('dragover',function(e){ e.preventDefault(); upZone.style.background='#EEF4FF'; });
  upZone.addEventListener('dragleave',function(){ upZone.style.background=''; });
  upZone.addEventListener('drop',function(e){
    e.preventDefault(); upZone.style.background='';
    Array.from(e.dataTransfer.files).forEach(function(f){ if(f.type.startsWith('image/')) loadFile(f); });
  });

  function loadFile(f){
    if(!f||!f.type.startsWith('image/')) return;
    var r=new FileReader();
    r.onload=function(e){
      var img=new Image();
      img.onload=function(){
        var el=createEl(img, f.name.replace(/\.[^.]+$/,''));
        elements.push(el);
        activeIdx=elements.length-1;
        renderList(); draw();
      };
      img.src=e.target.result;
    };
    r.readAsDataURL(f);
  }

  /* ── DRAG & RESIZE ON CANVAS ── */
  function canvasXY(e){
    var r=canvas.getBoundingClientRect();
    var cx=e.touches?e.touches[0].clientX:e.clientX;
    var cy=e.touches?e.touches[0].clientY:e.clientY;
    return{x:(cx-r.left)*(canvas.width/r.width),y:(cy-r.top)*(canvas.height/r.height)};
  }

  function hitEl(px,py){
    for(var i=elements.length-1;i>=0;i--){
      var el=elements[i];
      if(px>=el.x&&px<=el.x+el.w&&py>=el.y&&py<=el.y+el.h) return i;
    }
    return -1;
  }

  function nearHandle(px,py){
    if(activeIdx===null||activeIdx===undefined) return false;
    var el=elements[activeIdx]; if(!el) return false;
    var dx=px-(el.x+el.w),dy=py-(el.y+el.h);
    return Math.sqrt(dx*dx+dy*dy)<12;
  }

  canvas.addEventListener('mousedown',function(e){
    var p=canvasXY(e);
    if(nearHandle(p.x,p.y)){
      resizing=true; resizeIdx=activeIdx;
      var el=elements[resizeIdx];
      resizeStartX=p.x; resizeStartW=el.w;
      e.preventDefault(); return;
    }
    var idx=hitEl(p.x,p.y);
    if(idx>=0){
      activeIdx=idx; dragging=true;
      var el=elements[idx]; dragOffX=p.x-el.x; dragOffY=p.y-el.y;
      canvas.style.cursor='grabbing';
      renderList(); e.preventDefault();
    } else {
      if(activeIdx!==null){ activeIdx=null; renderList(); draw(); }
    }
  });

  window.addEventListener('mousemove',function(e){
    if(resizing){
      var p=canvasXY(e);
      var el=elements[resizeIdx];
      var newW=Math.max(20,resizeStartW+(p.x-resizeStartX));
      var sc=newW/el.img.width;
      el.w=newW; el.h=el.img.height*sc;
      el.sizePct=Math.round((newW/canvas.width)*100);
      el.x=Math.max(0,Math.min(el.x,canvas.width-el.w));
      el.y=Math.max(0,Math.min(el.y,canvas.height-el.h));
      renderList(); draw(); e.preventDefault();
    } else if(dragging){
      var p=canvasXY(e);
      var el=elements[activeIdx];
      el.x=Math.max(0,Math.min(p.x-dragOffX,canvas.width-el.w));
      el.y=Math.max(0,Math.min(p.y-dragOffY,canvas.height-el.h));
      draw(); e.preventDefault();
    } else {
      var p=canvasXY(e);
      if(nearHandle(p.x,p.y)) canvas.style.cursor='se-resize';
      else if(hitEl(p.x,p.y)>=0) canvas.style.cursor='grab';
      else canvas.style.cursor='default';
    }
  });

  window.addEventListener('mouseup',function(){ dragging=false; resizing=false; if(!dragging) canvas.style.cursor='default'; });

  canvas.addEventListener('touchstart',function(e){
    var p=canvasXY(e);
    var idx=hitEl(p.x,p.y);
    if(idx>=0){ activeIdx=idx; dragging=true; var el=elements[idx]; dragOffX=p.x-el.x; dragOffY=p.y-el.y; renderList(); e.preventDefault(); }
  },{passive:false});
  window.addEventListener('touchmove',function(e){
    if(!dragging) return;
    var p=canvasXY(e); var el=elements[activeIdx];
    el.x=Math.max(0,Math.min(p.x-dragOffX,canvas.width-el.w));
    el.y=Math.max(0,Math.min(p.y-dragOffY,canvas.height-el.h));
    draw(); e.preventDefault();
  },{passive:false});
  window.addEventListener('touchend',function(){ dragging=false; });

  /* ── FORMAT ── */
  document.querySelectorAll('input[name="spSz"]').forEach(function(r){
    r.addEventListener('change',function(){
      matSz=this.value;
      document.getElementById('spS20').classList.toggle('on',matSz==='20x24');
      document.getElementById('spS30').classList.toggle('on',matSz==='30x60');
      document.getElementById('spS40').classList.toggle('on',matSz==='40x90');
      var lbl=matSz==='40x90'?'40\u00d790':matSz==='20x24'?'20\u00d724':'30\u00d760';
      document.getElementById('spSzLbl').textContent='Format '+lbl+' cm \u2014 Rendu indicatif';
      updatePrice(); resize();
    });
  });

  /* ── PRICING ── */
  function updatePrice(){
    var pu=getUP(matSz,qty),total=pu*qty;
    var f=matSz==='40x90'?'40\u00d790 cm':matSz==='20x24'?'20\u00d724 cm':'30\u00d760 cm';
    document.getElementById('spPriceDetail').textContent=f;
    document.getElementById('spPriceFormula').innerHTML='<strong>'+qty+'</strong> u. \u00d7 <strong>'+fmt2(pu)+'</strong>/u';
    document.getElementById('spPriceTotal').textContent=fmt2(total);
    document.getElementById('spUnitPrice').textContent=fmt2(pu)+'/u';
  }

  function setQty(v){ v=Math.max(100,Math.round(v/10)*10); qty=v; qtyInput.value=v; updatePrice(); }
  document.getElementById('spQtyMinus').addEventListener('click',function(){ setQty(qty-10); });
  document.getElementById('spQtyPlus').addEventListener('click',function(){ setQty(qty+10); });
  qtyInput.addEventListener('change',function(){ setQty(parseInt(this.value)||100); });
  qtyInput.addEventListener('input',function(){ var v=parseInt(this.value); if(!isNaN(v)&&v>=100){ qty=v; updatePrice(); } });

  /* ── RESET ── */
  document.getElementById('spReset').addEventListener('click',function(){
    elements=[]; activeIdx=null; qty=100;
    qtyInput.value=100;
    applyColor('#0D0D12'); picker.value='#0D0D12';
    matSz='20x24';
    document.querySelector('input[name="spSz"][value="20x24"]').checked=true;
    document.getElementById('spS20').classList.add('on');
    document.getElementById('spS30').classList.remove('on');
    document.getElementById('spS40').classList.remove('on');
    document.getElementById('spSzLbl').textContent='Format 20\u00d724 cm \u2014 Rendu indicatif';
    renderList(); updatePrice(); resize();
  });

  /* ── DOWNLOAD PREVIEW ── */
  document.getElementById('spDl').addEventListener('click',function(){
    var a=document.createElement('a'); a.download='sourisi-apercu.png'; a.href=canvas.toDataURL('image/png'); a.click();
  });

  /* ── DEVIS PDF ── */
  function generateQuotePDF(client){
    var pu=getUP(matSz,qty),total=pu*qty;
    var f=matSz==='40x90'?'40\u00d790 cm':matSz==='20x24'?'20\u00d724 cm':'30\u00d760 cm';
    var dateStr=new Date().toLocaleDateString('fr-FR',{day:'2-digit',month:'long',year:'numeric'});
    var ref='SR-'+new Date().getFullYear()+'-'+Math.floor(Math.random()*90000+10000);
    var img=canvas.toDataURL('image/png');

    var html='<!DOCTYPE html><html lang="fr"><head><meta charset="UTF-8"><title>Devis Sourisi '+ref+'</title>'
      +'<style>*{box-sizing:border-box;margin:0;padding:0}body{font-family:Arial,sans-serif;color:#0D0D12;background:#fff;padding:40px;max-width:800px;margin:0 auto}'
      +'.hd{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:36px;padding-bottom:20px;border-bottom:2.5px solid #1E5FD8}'
      +'.brand{font-size:26px;font-weight:700;letter-spacing:-.5px}.brand span{color:#1E5FD8}'
      +'.ref{text-align:right;font-size:12px;color:#8A8FA8}.ref strong{font-size:15px;color:#0D0D12;display:block;margin-bottom:2px}'
      +'.client-box{display:grid;grid-template-columns:1fr 1fr;gap:0;border:1px solid #EDEEF2;border-radius:10px;overflow:hidden;margin-bottom:24px}'
      +'.ci{padding:12px 16px;border-right:1px solid #EDEEF2;border-bottom:1px solid #EDEEF2}'
      +'.ci:nth-child(2n){border-right:none}.ci:last-child{border-bottom:none;grid-column:1/-1;border-right:none}'
      +'.ci:nth-last-child(2):not(:nth-child(2n)){border-bottom:none}'
      +'.ci-l{font-size:9px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:#8A8FA8;margin-bottom:3px}'
      +'.ci-v{font-size:13px;font-weight:500;color:#0D0D12}'
      +'.st{font-size:9px;font-weight:700;letter-spacing:.1em;text-transform:uppercase;color:#8A8FA8;margin:24px 0 10px}'
      +'.prev{background:#F7F8FA;border-radius:10px;padding:16px;text-align:center;margin-bottom:20px}'
      +'.prev img{max-width:100%;border-radius:7px;max-height:200px;object-fit:contain}'
      +'.prev p{font-size:11px;color:#8A8FA8;margin-top:7px}'
      +'table{width:100%;border-collapse:collapse;margin-bottom:20px}'
      +'th{background:#F7F8FA;font-size:10px;text-transform:uppercase;letter-spacing:.05em;color:#8A8FA8;font-weight:600;padding:9px 12px;text-align:left;border-bottom:1px solid #EDEEF2}'
      +'td{padding:12px;border-bottom:1px solid #EDEEF2;font-size:13px;vertical-align:middle}'
      +'.tot{background:#F7F8FA;border-radius:10px;padding:16px 20px;margin-bottom:20px}'
      +'.tr{display:flex;justify-content:space-between;padding:7px 0;border-bottom:1px solid #EDEEF2;font-size:13px}'
      +'.tr:last-child{border-bottom:none;padding-top:14px}'
      +'.tr.big .tl{font-size:15px;font-weight:600;color:#0D0D12}.tr.big .tv{font-size:22px;font-weight:700;color:#1E5FD8}'
      +'.tl{color:#8A8FA8}.tv{font-weight:600}'
      +'.pay{display:flex;border:1px solid #EDEEF2;border-radius:10px;overflow:hidden;margin-bottom:20px}'
      +'.ph{flex:1;padding:16px 18px}.ph+.ph{border-left:1px solid #EDEEF2}'
      +'.phl{font-size:9px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:#8A8FA8;margin-bottom:5px}'
      +'.pha{font-size:20px;font-weight:700;color:#1E5FD8}'
      +'.phd{font-size:11px;color:#8A8FA8;margin-top:5px;line-height:1.4}'
      +'.phd strong{color:#0D0D12}.ph2 .pha{color:#0D0D12}'
      +'.cond{background:#EEF4FF;border-radius:8px;padding:14px 18px;margin-bottom:20px}'
      +'.cond-t{font-size:11px;font-weight:700;color:#1E5FD8;margin-bottom:8px}'
      +'.cond-g{display:grid;grid-template-columns:1fr 1fr;gap:5px}'
      +'.cil{font-size:11px;color:#0F3A9E;display:flex;align-items:flex-start;gap:5px}'
      +'.cil::before{content:"\\2713";color:#1E5FD8;font-weight:700;flex-shrink:0}'
      +'.warn{background:#FFF9E6;border:1px solid #F5C518;border-radius:7px;padding:11px 14px;margin-bottom:24px;font-size:11px;color:#6B5A00}'
      +'.ft{border-top:1px solid #EDEEF2;padding-top:16px;display:flex;justify-content:space-between;align-items:center}'
      +'.ftb{font-size:13px;font-weight:700}.ftb span{color:#1E5FD8}'
      +'.ftn{font-size:10px;color:#C5C8D4;text-align:right}'
      +'@media print{body{padding:20px}@page{margin:12mm}}</style></head><body>';

    html += '<div class="hd"><div><div class="brand">Sourisi<span>.</span></div>'
      +'<div style="font-size:12px;color:#8A8FA8;margin-top:3px">Tapis de souris personnalis\u00e9s pour entreprises</div></div>'
      +'<div class="ref"><strong>'+ref+'</strong>Devis N\u00b0 \u2014 \u00e9mis le '+dateStr+'</div></div>'
      +'<div class="st">Coordonn\u00e9es du client</div>'
      +'<div class="client-box">'
      +'<div class="ci"><div class="ci-l">Pr\u00e9nom &amp; Nom</div><div class="ci-v">'+client.prenom+' '+client.nom+'</div></div>'
      +'<div class="ci"><div class="ci-l">Entreprise</div><div class="ci-v">'+client.entreprise+'</div></div>'
      +'<div class="ci"><div class="ci-l">Email</div><div class="ci-v">'+client.email+'</div></div>'
      +'<div class="ci"><div class="ci-l">T\u00e9l\u00e9phone</div><div class="ci-v">'+client.tel+'</div></div>'
      +'<div class="ci"><div class="ci-l">SIRET</div><div class="ci-v">'+client.siret+'</div></div>'
      +'</div>'
      +(client.message&&client.message!=='Aucune question'?'<div class="st">Message</div><div style="background:#F7F8FA;border-radius:8px;padding:12px 16px;margin-bottom:20px;font-size:13px;color:#0D0D12;line-height:1.6">'+client.message+'</div>':'')
      +'<div class="st">Aper\u00e7u de votre tapis</div>'
      +'<div class="prev"><img src="'+img+'" alt="Aper\u00e7u"><p>Rendu indicatif \u2014 mockup final valid\u00e9 avec notre \u00e9quipe</p></div>'
      +'<div class="st">D\u00e9tail de la commande</div>'
      +'<table><thead><tr><th>Produit</th><th>Couleur</th><th style="text-align:center">Qt\u00e9</th><th style="text-align:right">P.U. HT</th><th style="text-align:right">Total HT</th></tr></thead>'
      +'<tbody><tr>'
      +'<td><strong>Tapis de souris Sourisi \u2014 '+f+'</strong><br><span style="font-size:11px;color:#8A8FA8">Microfibre premium \u00b7 Bords surpiq\u00e9s \u00b7 Base antid\u00e9rapante \u00b7 Impression HD</span></td>'
      +'<td><div style="display:flex;align-items:center;gap:7px"><div style="width:13px;height:13px;border-radius:50%;background:'+color+';border:1px solid rgba(0,0,0,.1);flex-shrink:0"></div><span style="font-size:12px;font-family:monospace">'+color.toUpperCase()+'</span></div></td>'
      +'<td style="text-align:center;font-weight:700">'+qty+'</td>'
      +'<td style="text-align:right">'+fmt2(pu)+'</td>'
      +'<td style="text-align:right;font-weight:700">'+fmt2(total)+'</td>'
      +'</tr></tbody></table>'
      +'<div class="st">R\u00e9capitulatif financier</div>'
      +'<div class="tot">'
      +'<div class="tr"><span class="tl">Total HT</span><span class="tv">'+fmt2(total)+'</span></div>'
      +'<div class="tr big"><span class="tl">Total</span><span class="tv">'+fmt2(total)+'</span></div>'
      +'<div style="font-size:10px;color:#8A8FA8;font-style:italic;margin-top:10px;padding-top:10px;border-top:1px solid #EDEEF2">TVA non applicable, art. 293 B du CGI</div>'
      +'</div>'
      +'<div class="st">Tarifs d\u00e9gressifs \u2014 '+f+'</div>'
      +'<table style="margin-bottom:20px"><thead><tr><th>Quantit\u00e9</th><th style="text-align:right">P.U. HT</th><th style="text-align:right">\u00c9conomie</th></tr></thead><tbody>'
      +PRICING[matSz].map(function(t,i){
        var base=PRICING[matSz][0].pu,sv=i===0?'\u2014':'-'+(((base-t.pu)/base)*100).toFixed(0)+'%';
        var on=(qty>=t.min&&qty<=t.max),bg=on?'background:#EEF4FF;':'',fw=on?'font-weight:700;color:#1E5FD8;':'';
        var mx=t.max===99999?'+':t.max+' u';
        return '<tr style="'+bg+'"><td style="'+fw+'">'+t.min+' \u2014 '+mx+'</td><td style="text-align:right;'+fw+'">'+fmt2(t.pu)+'</td><td style="text-align:right;color:'+(i===0?'#C5C8D4':'#22C55E')+'">'+sv+'</td></tr>';
      }).join('')+'</tbody></table>'
      +'<div class="st">Conditions &amp; d\u00e9lais</div>'
      +'<div class="cond"><div class="cond-t">Inclus dans cette commande</div><div class="cond-g">'
      +'<div class="cil">Mockup gratuit sous 24h</div><div class="cil">R\u00e9visions illimit\u00e9es</div>'
      +'<div class="cil">Production + livraison : 4 \u00e0 5 semaines</div><div class="cil">Livraison offerte \u2014 France m\u00e9tropolitaine</div>'
      +'<div class="cil">Satisfaction garantie</div><div class="cil">Interlocuteur d\u00e9di\u00e9</div>'
      +'</div></div>'
      +'<div class="st">Conditions de paiement</div>'
      +'<div class="pay">'
      +'<div class="ph"><div class="phl">Acompte \u2014 50 %</div><div class="pha">'+fmt2(total*.5)+'</div><div class="phd">\u00c0 la <strong>validation mutuelle du devis</strong>. La production d\u00e9marre \u00e0 r\u00e9ception.</div></div>'
      +'<div class="ph ph2"><div class="phl">Solde \u2014 50 %</div><div class="pha">'+fmt2(total*.5)+'</div><div class="phd">\u00c0 la <strong>r\u00e9ception des tapis conformes</strong>. Aucun paiement avant livraison v\u00e9rifi\u00e9e.</div></div>'
      +'</div>'
      +'<div style="font-size:11px;color:#8A8FA8;margin-bottom:20px;padding:10px 14px;background:#F7F8FA;border-radius:7px">Paiement par virement bancaire. RIB transmis \u00e0 la validation du devis.</div>'
      +'<div class="warn"><strong>Devis valable 30 jours</strong> \u2014 Prix HT incluant personnalisation, production et livraison offerte en France m\u00e9tropolitaine.</div>'
      +'<div class="ft"><div><div class="ftb">Sourisi<span>.</span></div>'
      +'<div style="font-size:11px;color:#8A8FA8;margin-top:2px">contact@sourisi.com \u00b7 sourisi.com</div></div>'
      +'<div class="ftn">Devis g\u00e9n\u00e9r\u00e9 automatiquement<br>'+ref+' \u00b7 '+dateStr+'</div></div>'
      +'</body></html>';

    var w=window.open('','_blank','width=900,height=750,scrollbars=yes');
    w.document.write(html); w.document.close(); w.focus();
    w.onload=function(){ w.print(); };
  }

  /* ── MODAL ── */
  var overlay    =document.getElementById('spModalOverlay');
  var modalClose =document.getElementById('spModalClose');
  var modalSubmit=document.getElementById('spModalSubmit');

  document.getElementById('spQuoteBtn').addEventListener('click',function(){
    overlay.classList.add('open');
    document.getElementById('spPrenom').focus();
  });

  function closeModal(){ overlay.classList.remove('open'); }
  modalClose.addEventListener('click',closeModal);
  overlay.addEventListener('click',function(e){ if(e.target===overlay) closeModal(); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') closeModal(); });

  modalSubmit.addEventListener('click',function(){
    var ok=true;
    function check(fId,iId,testFn){
      var field=document.getElementById(fId),input=document.getElementById(iId);
      var val=(input.value||'').trim(),valid=testFn(val);
      field.classList.toggle('has-err',!valid); input.classList.toggle('err',!valid);
      if(!valid) ok=false; return val;
    }
    var prenom    =check('sfPrenom',    'spPrenom',    function(v){return v.length>=2;});
    var nom       =check('sfNom',       'spNom',       function(v){return v.length>=2;});
    var entreprise=check('sfEntreprise','spEntreprise',function(v){return v.length>=2;});
    var email     =check('sfEmail',     'spEmail',     function(v){return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);});
    var tel       =check('sfTel',       'spTel',       function(v){return v.replace(/[\s\-\+\(\)]/g,'').length>=8;});
    var siret     =check('sfSiret',     'spSiret',     function(v){return v.replace(/[\s\-]/g,'').length===14;});
    var message   =(document.getElementById('spMessage').value||'').trim();
    if(!ok) return;

    modalSubmit.disabled=true;
    modalSubmit.innerHTML='En cours\u2026';

    var pu=getUP(matSz,qty),total=pu*qty;
    var f=matSz==='40x90'?'40\u00d790 cm':matSz==='20x24'?'20\u00d724 cm':'30\u00d760 cm';
    var dateStr=new Date().toLocaleDateString('fr-FR',{day:'2-digit',month:'long',year:'numeric'});
    var ref='SR-'+new Date().getFullYear()+'-'+Math.floor(Math.random()*90000+10000);
    var client={prenom:prenom,nom:nom,entreprise:entreprise,email:email,tel:tel,siret:siret,message:message||'Aucune question'};

    var tmpC=document.createElement('canvas');
    var ratio=canvas.height/canvas.width;
    tmpC.width=480;
    tmpC.height=Math.round(480*ratio);
    var tmpCtx=tmpC.getContext('2d');
    tmpCtx.drawImage(canvas,0,0,tmpC.width,tmpC.height);
    var apercu=tmpC.toDataURL('image/jpeg',0.45);

    if(typeof emailjs !== 'undefined'){
      var EMAILJS_SERVICE_ID='service_kt3u4qj';
      var EMAILJS_TEMPLATE_ID='template_c3dvchf';
      emailjs.send(EMAILJS_SERVICE_ID,EMAILJS_TEMPLATE_ID,{
        to_email:'contact@sourisi.com', reply_to:client.email,
        prenom:client.prenom, nom:client.nom, entreprise:client.entreprise,
        email:client.email, tel:client.tel, siret:client.siret, message:client.message,
        format:f, qty:qty, total_ht:fmt2(total), total_ttc:fmt2(total*1.2),
        couleur:color.toUpperCase(), ref:ref, date:dateStr,
        apercu:apercu
      }).then(function(){
        console.log('EmailJS OK');
      },function(err){
        console.warn('EmailJS error:', JSON.stringify(err));
      });
    }

    modalSubmit.disabled=false;
    modalSubmit.innerHTML='G\u00e9n\u00e9rer et t\u00e9l\u00e9charger mon devis';

    closeModal();
    generateQuotePDF(client);
  });

  ['spPrenom','spNom','spEntreprise','spEmail','spTel','spSiret'].forEach(function(id){
    var el=document.getElementById(id);
    if(el) el.addEventListener('input',function(){
      var f=this.closest('.sp-field');
      if(f){f.classList.remove('has-err');this.classList.remove('err');}
    });
  });

  /* ── INIT ── */
  window.addEventListener('resize', resize);
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){ updatePrice(); resize(); });
  } else {
    updatePrice(); resize();
  }

})();